import isEmpty from 'lodash/isEmpty';
export const getEmailErrorText = ({ isTouched, errors }, fieldRequired, invalidEmail) => {
    if (!isTouched || isEmpty(errors)) {
        return '';
    }
    return errors.length > 1 ? fieldRequired : invalidEmail;
};
